<template>
	<div>
		<a href="#" class="legend-item-tool" @click="toggleTransparencySlider()" v-if="layer.legendToolTransparency" title="Transparency"><span class="icon-transparency"></span></a>
	  <transparency-slider
	  	v-if="layer.legendToolTransparency" 
	  	:show="showTransparencySlider" 
	  	:initValue="getOpacity(layer)" 
	  	@set-opacity="setOpacity($event, layer)"
	  >
	  </transparency-slider>
	</div>
</template>

<script>
import containerMixes from '../mixins/legend/legend-container.js'

import TransparencySlider from '../Legend/TransparencySlider.vue'
const components = {
	TransparencySlider
}
export default {

  name: 'ItemTools',
  mixins: [containerMixes],
  components,
  props: {
  	layer: {
  		type: Object,
  		required: true
  	}
  },
  data () {
    return {
    	showTransparencySlider: false
    }
  },
  methods: {
  	toggleTransparencySlider(){
  		this.showTransparencySlider = !this.showTransparencySlider
  	}
  }
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// resources/js/map/MapComponents/Legend/ItemTools.vue